import store from "@/store";
import isEmpty from "lodash/isEmpty";

class RequestHeadersBuilder {
  constructor() {
    this.headers = new Headers();
  }

  addHeader(header) {
    for (const [key, value] of Object.entries(header)) {
      this.headers.set(key, value);
    }

    return this;
  }

  addOrganizationHeader() {
    let organization = store.state.currentlyActiveOrganization;

    if (!isEmpty(organization)) {
      return this.addHeader({ Organization: `${organization.organization.id}` });
    }

    return this;
  }
  /**
   * Adds current url and previous url to headers;
   */
  addUrlHeaders() {
    this.addHeader({ Url: window.location.href });

    if (store.state.previousRoute) {
      const fullPreviousRoute =
        document.location.protocol + "//" + document.location.hostname + store.state.previousRoute;

      return this.addHeader({ "Previous-Url": fullPreviousRoute });
    }

    return this;
  }

  addImpersonateHeader() {
    if (store.state.user.impersonate) {
      return this.addHeader({ Impersonate: store.state.user.impersonate });
    }

    return this;
  }

  get() {
    return this.headers;
  }
}

export const httpDataHeaders = () => {
  const headers = new RequestHeadersBuilder();

  headers
    .addHeader({
      Accept: "application/ld+json",
      "Content-Type": "application/ld+json",
    })
    .addOrganizationHeader()
    .addUrlHeaders()
    .addImpersonateHeader();

  return headers.get();
};

export const httpAuthHeaders = () => {
  const headers = new RequestHeadersBuilder();

  headers
    .addHeader({
      Accept: "application/ld+json",
      "Content-Type": "application/ld+json",
    })
    .addUrlHeaders();

  return headers.get();
};

export const httpMediaObjectHeaders = () => {
  const headers = new RequestHeadersBuilder();

  headers
    .addHeader({
      Accept: "application/ld+json",
    })
    .addOrganizationHeader()
    .addUrlHeaders()
    .addImpersonateHeader();

  return headers.get();
};

export const httpTextHeaders = () => {
  const headers = new RequestHeadersBuilder();

  headers
    .addHeader({
      Accept: "application/ld+json",
    })
    .addOrganizationHeader()
    .addUrlHeaders()
    .addImpersonateHeader();

  return headers.get();
};
